import { HTMLMotionProps, motion } from 'framer-motion';
import * as animationData from '../../assets/animations/animation.json';
import Lottie, { Options } from 'react-lottie';
import styled from 'styled-components';
interface LogoProps extends HTMLMotionProps<'div'> {
  dark?: boolean;
}

const Orbit: React.FC<LogoProps> = ({ dark = false }) => {
  const rotationVariants = {
    rotate: {
      rotate: 360,
      transition: {
        repeat: Infinity, // Infinite loop
        duration: 100, // Duration for one full rotation
        ease: 'linear', // Smooth rotation
      },
    },
  };

  const defaultOptions: Options = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <OrbitWrapper animate="rotate" variants={rotationVariants}>
      <Lottie options={defaultOptions} />

      {/* 
      // old design
      {dark ? (
        <svg
          width="117"
          height="40"
          viewBox="0 0 117 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1.28134"
            y="10.223"
            width="8"
            height="8"
            transform="rotate(-19.964 1.28134 10.223)"
            stroke="#003166"
            strokeWidth="2"
          />
          <circle
            cx="18.4067"
            cy="16.6169"
            r="4"
            stroke="#003166"
            strokeWidth="2"
          />
          <path
            d="M5.63706 27.5383L10.8105 21.7087L13.2724 29.1039L5.63706 27.5383Z"
            stroke="#003166"
            strokeWidth="2"
          />
          <path
            d="M53.1987 28L50.0307 11.68H45.7587L42.3747 23.128L38.9667 11.68H34.6947L31.5267 28H35.4867L37.4067 16.744L40.5987 28H44.1267L47.3187 16.744L49.2387 28H53.1987ZM55.8648 21.448C55.8648 21.448 55.9848 19.48 58.2408 19.48C60.4248 19.48 60.5928 21.448 60.5928 21.448H55.8648ZM64.0488 22.48C64.0488 19.096 61.3848 17.176 58.1688 17.176C54.6168 17.176 52.0008 19.408 52.0008 22.72C52.0008 26.08 54.5208 28.24 58.1688 28.24C60.9768 28.24 63.2328 26.848 63.8568 24.064H60.1848C60.1608 24.832 59.3688 25.672 58.0968 25.672C56.6808 25.672 55.8168 24.376 55.8168 23.152H64.0248C64.0248 22.936 64.0488 22.696 64.0488 22.48ZM67.7752 22.72C67.7752 21.328 68.8552 20.08 70.2952 20.08C71.7352 20.08 72.8152 21.328 72.8152 22.72C72.8152 24.112 71.7352 25.36 70.2952 25.36C68.8552 25.36 67.7752 24.112 67.7752 22.72ZM67.7752 34V26.728C68.4952 27.808 70.0312 28.24 71.3992 28.24C74.3992 28.24 76.6552 25.648 76.6552 22.72C76.6552 19.792 74.3992 17.176 71.3992 17.176C70.0312 17.176 68.7112 17.56 67.7752 18.712V17.416H64.1752V34H67.7752ZM87.6048 22C87.6048 19.12 86.4528 17.176 83.6208 17.176C82.2288 17.176 81.1008 17.8 80.3808 18.712V10H76.7808V28H80.3808V22.72C80.3808 21.28 81.2688 20.08 82.3968 20.08C83.5248 20.08 84.0048 20.752 84.0048 22V28H87.6048V22ZM96.2367 22.72C96.2367 24.112 95.1567 25.36 93.7167 25.36C92.2767 25.36 91.1967 24.112 91.1967 22.72C91.1967 21.328 92.2767 20.08 93.7167 20.08C95.1567 20.08 96.2367 21.328 96.2367 22.72ZM99.8367 17.44H96.2367V18.712C95.3007 17.56 93.9567 17.176 92.6127 17.176C89.6127 17.176 87.3567 19.792 87.3567 22.72C87.3567 25.648 89.6127 28.24 92.6127 28.24C93.9567 28.24 95.5167 27.808 96.2367 26.728V28H99.8367V17.44ZM104.162 28V10H100.562V28H104.162ZM109.407 20.2H111.327V17.416H109.407V13.384H105.831V17.416H103.911V20.2H105.831V28H109.407V20.2ZM110.886 13.792C110.886 14.944 111.822 15.904 112.998 15.904C114.15 15.904 115.11 14.944 115.11 13.792C115.11 12.616 114.15 11.68 112.998 11.68C111.822 11.68 110.886 12.616 110.886 13.792ZM114.798 28V17.416H111.198V28H114.798Z"
            fill="#02001E"
          />
        </svg>
      ) : (
        <svg
          width="117"
          height="40"
          viewBox="0 0 117 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1.28134"
            y="10.2229"
            width="8"
            height="8"
            transform="rotate(-19.964 1.28134 10.2229)"
            stroke="#ffffff"
            strokeWidth="2"
          />
          <circle
            cx="18.4067"
            cy="16.6167"
            r="4"
            stroke="#ffffff"
            strokeWidth="2"
          />
          <path
            d="M5.63706 27.5381L10.8105 21.7084L13.2724 29.1036L5.63706 27.5381Z"
            stroke="#ffffff"
            strokeWidth="2"
          />
          <path
            d="M53.1987 28L50.0307 11.68H45.7587L42.3747 23.128L38.9667 11.68H34.6947L31.5267 28H35.4867L37.4067 16.744L40.5987 28H44.1267L47.3187 16.744L49.2387 28H53.1987ZM55.8648 21.448C55.8648 21.448 55.9848 19.48 58.2408 19.48C60.4248 19.48 60.5928 21.448 60.5928 21.448H55.8648ZM64.0488 22.48C64.0488 19.096 61.3848 17.176 58.1688 17.176C54.6168 17.176 52.0008 19.408 52.0008 22.72C52.0008 26.08 54.5208 28.24 58.1688 28.24C60.9768 28.24 63.2328 26.848 63.8568 24.064H60.1848C60.1608 24.832 59.3688 25.672 58.0968 25.672C56.6808 25.672 55.8168 24.376 55.8168 23.152H64.0248C64.0248 22.936 64.0488 22.696 64.0488 22.48ZM67.7752 22.72C67.7752 21.328 68.8552 20.08 70.2952 20.08C71.7352 20.08 72.8152 21.328 72.8152 22.72C72.8152 24.112 71.7352 25.36 70.2952 25.36C68.8552 25.36 67.7752 24.112 67.7752 22.72ZM67.7752 34V26.728C68.4952 27.808 70.0312 28.24 71.3992 28.24C74.3992 28.24 76.6552 25.648 76.6552 22.72C76.6552 19.792 74.3992 17.176 71.3992 17.176C70.0312 17.176 68.7112 17.56 67.7752 18.712V17.416H64.1752V34H67.7752ZM87.6048 22C87.6048 19.12 86.4528 17.176 83.6208 17.176C82.2288 17.176 81.1008 17.8 80.3808 18.712V10H76.7808V28H80.3808V22.72C80.3808 21.28 81.2688 20.08 82.3968 20.08C83.5248 20.08 84.0048 20.752 84.0048 22V28H87.6048V22ZM96.2367 22.72C96.2367 24.112 95.1567 25.36 93.7167 25.36C92.2767 25.36 91.1967 24.112 91.1967 22.72C91.1967 21.328 92.2767 20.08 93.7167 20.08C95.1567 20.08 96.2367 21.328 96.2367 22.72ZM99.8367 17.44H96.2367V18.712C95.3007 17.56 93.9567 17.176 92.6127 17.176C89.6127 17.176 87.3567 19.792 87.3567 22.72C87.3567 25.648 89.6127 28.24 92.6127 28.24C93.9567 28.24 95.5167 27.808 96.2367 26.728V28H99.8367V17.44ZM104.162 28V10H100.562V28H104.162ZM109.407 20.2H111.327V17.416H109.407V13.384H105.831V17.416H103.911V20.2H105.831V28H109.407V20.2ZM110.886 13.792C110.886 14.944 111.822 15.904 112.998 15.904C114.15 15.904 115.11 14.944 115.11 13.792C115.11 12.616 114.15 11.68 112.998 11.68C111.822 11.68 110.886 12.616 110.886 13.792ZM114.798 28V17.416H111.198V28H114.798Z"
            fill="#FFFFFF"
          />
        </svg>
      )} */}
    </OrbitWrapper>
  );
};

export default Orbit;

const OrbitWrapper = styled(motion.div)`
  user-select: none;
  pointer-events: none;
  width: 220px;

  &:focus-visible,
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  @media (min-width: 480px) {
    width: 300px;
  }

  @media (min-width: 768px) {
    width: 400px;
  }

  @media (min-width: 1024px) {
    width: max-content;
  }

  div[role='button'] {
    &:focus-visible,
    &:focus {
      outline: 3px solid red;
      box-shadow: none !important;
    }
  }
`;
